import { api } from '../../api'
import { ApiParams, TrailersResponse } from '../../types'

const getTrailers = async ({ filters }: ApiParams) => {
  const response = await api.get<TrailersResponse>('/trailers', {
    params: filters,
  })

  return response.data.trailers
}

const TrailersViewApi = { getTrailers }

export default TrailersViewApi
